import { DELETE_SCALE_DEVICE_REQUEST, GET_SCALE_DEVICE_LIST, GET_SCALE_DEVICE_LIST_REQUEST, SAVE_SCALE_DEVICE_REQUEST, SAVE_SCALE_DEVICE_SUCCESS, UPDATE_SCALE_DEVICE_REQUEST } from "../constants/action-types";
import { DELETE_SCALE_DEVICE, SAVE_SCALE_DEVICE, UPDATE_SCALE_DEVICE } from "../constants/messages";
import { apiResponse, defaultAgent } from "../helpers/web-agent";
import { tokenExpired } from "./auth";
import { toastError, toastSuccess } from "./toast";



export const saveScaleDeviceRequest = () => ({ type: SAVE_SCALE_DEVICE_REQUEST });
export const saveScaleDevice = (payload) => ({ type: SAVE_SCALE_DEVICE_SUCCESS, payload });
export const getScaleDeviceRequest = () => ({ type: GET_SCALE_DEVICE_LIST_REQUEST });
export const getScaleDeviceList = (payload) => ({ type: GET_SCALE_DEVICE_LIST, payload });
export const deleteScaleDeviceRequest = () => ({ type: DELETE_SCALE_DEVICE_REQUEST });
export const deleteScaleDevice = (payload) => ({ type: SAVE_SCALE_DEVICE_SUCCESS, payload});
export const updateScaleDeviceRequest = () => ({ type: UPDATE_SCALE_DEVICE_REQUEST });
export const updateScaleDevice = (payload) => ({ type: UPDATE_SCALE_DEVICE_REQUEST, payload });


export const createScaleDevice = (data, cb) => {
  return dispatch => {
    defaultAgent.post('/api/scale/device/save', data)
      .then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
          dispatch(toastError(agentResult.message));
          dispatch(tokenExpired());
        } else if (agentResult.code === SAVE_SCALE_DEVICE.code) {
          dispatch(scaleDeviceList({ farm_uuid: data.farm_uuid }));
          if (cb) cb(true);
          dispatch(toastSuccess(agentResult.message));
        } else if (agentResult.message) {
          if (cb) cb(false);
          dispatch(toastError(agentResult.message));
        }
      }).catch(ex => {
        if (cb) cb(false);
        dispatch(toastError(ex.message));
      });
  }
}

export const scaleDeviceList = (data, cb) => {
  return dispatch => {
    dispatch(getScaleDeviceRequest());
    defaultAgent.get('/api/scale/device/list', data)
      .then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
          dispatch(toastError(agentResult.message));
          dispatch(tokenExpired());
        } else if (agentResult) {
          dispatch(getScaleDeviceList(agentResult));
        }
      }).catch(ex => {
        if (cb) cb(false);
        dispatch(toastError(ex.message));
      });
  }
}

export const deleteScaleDeviceInfo = (data, cb) => {
  return dispatch => {
    defaultAgent.put('/api/scale/device/delete', data)
      .then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
          dispatch(toastError(agentResult.message));
          dispatch(tokenExpired());
        } else if (agentResult.code === DELETE_SCALE_DEVICE.code) {
          dispatch(scaleDeviceList({ farm_uuid: data.farm_uuid }));
          if (cb) cb(true);
          dispatch(toastSuccess(agentResult.message));
        } else if (agentResult.message) {
          if (cb) cb(false);
          dispatch(toastError(agentResult.message));
        }
      }).catch(ex => {
        if (cb) cb(false);
        dispatch(toastError(ex.message));
      });
  }
}

export const updateScaleDeviceInfo = (data, cb) => {
  return dispatch => {
    defaultAgent.post('/api/scale/device/update', data)
      .then(res => {
        const agentResult = apiResponse(res, {});
        if (agentResult.isUnauthorized) {
          dispatch(toastError(agentResult.message));
          dispatch(tokenExpired());
        } else if (agentResult.code === UPDATE_SCALE_DEVICE.code) {
          dispatch(scaleDeviceList({ farm_uuid: data.farm_uuid }));
          if (cb) cb(true);
          dispatch(toastSuccess(agentResult.message));
        } else if (agentResult.message) {
          if (cb) cb(false);
          dispatch(toastError(agentResult.message));
        }
      }).catch(ex => {
        if (cb) cb(false);
        dispatch(toastError(ex.message));
      });
  }
}